import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const container = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
  padding: 1rem;
  margin: 1rem 0;

  > button:first-of-type {
    font-size: 1rem;
    padding: 0.5rem 1rem;
    height: unset;
  }
`;

export const dosageName = (theme: Theme) => css`
  width: 100%;
  justify-content: space-between;

  &:hover svg {
    color: ${theme.danger.backgroundBase};
  }

  & > div:nth-of-type(2) {
    margin-right: 0;
  }
`;

export const dosageMinMax = css`
  display: flex;
  column-gap: 0.5rem;
  margin: 1rem 0 0.5rem;
`;

export const bold = css`
  font-weight: ${typography.weightSemiBold};
`;
